import { render, staticRenderFns } from "./selectOption.vue?vue&type=template&id=35abbae5&scoped=true"
import script from "./selectOption.vue?vue&type=script&lang=js"
export * from "./selectOption.vue?vue&type=script&lang=js"
import style0 from "./selectOption.vue?vue&type=style&index=0&id=35abbae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abbae5",
  null
  
)

export default component.exports